function FAQS({ data }) {
  const { heading, intro, items } = data;
  const faqs = items.map(({ question, answer }, index) => {
    const formatedIndex = String(index + 1).padStart(2, "0");

    return (
      <div key={index + 1} className="py-2 px-5">
        <div className="FAQ">
          <div
            className="accordion"
            id="faqAccordion"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  <div className="d-md-flex">
                    <div className="px-5 FAQNo">{formatedIndex}</div>
                    <div className=" ps-4 faqanswertitle pt-3">{question}</div>
                  </div>
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body pt-3 pb-4 ">{answer}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });
  return (
    <>
      <div className="homeSegment7  p-md-5 p-4">
        <div className="d-flex pt-4">
          <div className="homeSegment1aboutusline"></div>
          <div className="homeSegment1aboutus ps-2">{heading}</div>
        </div>
        <div className="homeSegment3intro py-3">{intro}</div>

        <div className="FAQs">{faqs}</div>
      </div>
    </>
  );
}

export default FAQS;
